const baseConfig = {
  test: {
    aegisKey: 'W7bpGFadb136db4bo7',
    aegisV2Key: 'aegis-df01ab80f22dedbc',
    zongjianId: 800036854, // 总检参数
    zjHospIds: [10001], // 展示总检的医院ID

  },
  production: {
    aegisKey: 'KJPaZSqDEoO04dleQ3',
    aegisV2Key: 'aegis-bb1e9566d5aa5f2b',
    zongjianId: 800001980, // 总检参数
    zjHospIds: [30000], // 展示总检的医院ID
  },
};
let env = process.env.VUE_APP_ENV;
env === 'development' && (env = 'test');
env === 'preview' && (env = 'production');
export default baseConfig[env];
